export default __webpack_public_path__ + "static/04_kafka-topics-2d3a50501a810f61e00575340264078d.png";